function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.39961 4C1.90172 5.06603 1.59961 6.46634 1.59961 8C1.59961 9.53366 1.90172 10.934 2.39961 12M13.5996 4C14.0975 5.06603 14.3996 6.46634 14.3996 8C14.3996 9.53366 14.0975 10.934 13.5996 12",
  stroke: "#FF3A3A",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.28078 5.60001C4.98205 6.23962 4.80078 7.07981 4.80078 8.00001C4.80078 8.9202 4.98205 9.76039 5.28078 10.4M10.7208 5.60001C11.0195 6.23962 11.2008 7.07981 11.2008 8.00001C11.2008 8.9202 11.0195 9.76039 10.7208 10.4",
  stroke: "#FF3A3A",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 6.40039,
  y: 6.40001,
  width: 3.2,
  height: 3.2,
  rx: 1.6,
  fill: "#FF3A3A"
});

var SvgWebcast = function SvgWebcast(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWebcast, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/webcast.1a278003.svg";
export { ForwardRef as ReactComponent };